/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  InAppProductsUserControllerFindAllQueryResponse,
  InAppProductsUserControllerFindAllPathParams,
  InAppProductsUserControllerFindAll401,
} from '../types/InAppProductsUserControllerFindAll.ts';

function getInAppProductsUserFindAllUrl(platform: InAppProductsUserControllerFindAllPathParams['platform']) {
  const res = { method: 'GET', url: `/api/user/in-app-products/${platform}` as const };
  return res;
}

/**
 * {@link /api/user/in-app-products/:platform}
 */
export async function inAppProductsUserFindAll(
  platform: InAppProductsUserControllerFindAllPathParams['platform'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    InAppProductsUserControllerFindAllQueryResponse,
    ResponseErrorConfig<InAppProductsUserControllerFindAll401>,
    unknown
  >({ method: 'GET', url: getInAppProductsUserFindAllUrl(platform).url.toString(), ...requestConfig });
  return res.data;
}
